module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp1_2.90d13203.png";